import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const IdUnidadDeMedidaFormGroup = ({
  values,
  setValues,
  handleChange,
  iError,
  iTouched,
  fIsSubmitting
}) => {
  const __zariContext = React.useContext(ZariContext)
  const [unidadesDeMedida, setUnidadesDeMedida] = React.useState([])

  React.useEffect(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.UNIDADESMEDIDA)
      .then(({ data }) => setUnidadesDeMedida(data))
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext])

  return (
    <Form.Group>
      <Form.Label text='U. MEDIDA' htmlFor='select-idUnidadDeMedida' xs={4} alignRightAt='xs' />
      <Col xs={8}>
        <Field name='_idUnidadDeMedida'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-idUnidadDeMedida'
              onChange={e => {
                handleChange(e)
                values._idUnidadDeMedida = e.target.value
                values.nombreUnidadDeMedida = e.target.options[e.target.selectedIndex].getAttribute(
                  'data-nombre'
                )
                setValues(values)
              }}
            >
              <option value=''>Seleccionar</option>
              {unidadesDeMedida.map((val, key) => (
                <option key={key} value={val._id} data-nombre={val.nombre}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(IdUnidadDeMedidaFormGroup)
